import {Link} from 'react-router-dom'

const LinkComponent = ({link, component})=>{
  return (
    <Link to={link}>
        {component}
    </Link>
  );   
};

export default LinkComponent;